import {Service} from "../Service";

export class PlanService extends Service {
    constructor() {
        super('plan/');

    }

    obtenerPlanesPorCuenta(params, config) {
        this.onStart();
        return this.http.get(this.getUrl(["planes", "cuenta"], params), config)
            .then((response) => this.onData(response))
            .then((response) => this.onData(response))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

}